var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"nav-button link-button button",attrs:{"type":"submit"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('img',{attrs:{"src":_vm.whiteRightIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }